export const isBrowser = () => typeof window !== 'undefined';

export const isExternal = (url: string): boolean => {
  if (!isBrowser()) return true;
  const tmp = document.createElement('a');
  tmp.href = url;
  return tmp.host !== window.location.host;
} 